<div *ngIf='initReady' [class.invalid]='hasError'>
  <editor
    [attr.data-testid]="getTestId()"
    #editorComponent
    (ngModelChange)='onChangeHandler($event)'
    (onInit)='onInit()'
    [(ngModel)]='value'
    [disabled]='disabled'
    [init]='init'
  ></editor>
  <ng-container *ngIf='!componentReady'>
    <mat-spinner></mat-spinner>
  </ng-container>
</div>
